import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingModule } from './components/landing/landing.module';
import { ProductsModule } from './components/products/products.module';
import { MainModule } from './components/main/main.module';
import { RecipesModule } from './components/recipes/recipes.module';
import { AboutUsModule } from './components/about-us/about-us.module';
import { ContactUsModule } from './components/contact-us/contact-us.module';
import { ProfessionalsModule } from './components/professionals/professionals.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MainModule,
    LandingModule,
    ProductsModule,
    RecipesModule,
    ContactUsModule,
    AboutUsModule,
    ProfessionalsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
